import * as React from 'react';
import { BookOpen, Hammer, User2Icon, User } from 'lucide-react';

import { NavMain } from 'src/components/common/navbar/sidebar/nav-main';
import { NavResources } from 'src/components/common/navbar/sidebar/nav-projects';
import { NavUser } from 'src/components/common/navbar/sidebar/nav-user';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from 'src/components/ui/sidebar';
// @ts-ignore
import Reclaim from '../../../../assets/icons/reclaim.svg';

import { useAppDispatch } from 'src/redux/hooks';
import { getUserDisplayName } from 'src/redux/user/selectors';
import { getPhotoURL } from 'src/redux/user/selectors';
import { useAppSelector } from 'src/redux/hooks';
import { useNavigate } from 'react-router-dom';
import { getUserType } from 'src/redux/user/selectors';
import { getAuth, signOut } from 'firebase/auth';
import { app } from 'src/configs/firebaseApp';
import { useContext } from 'react';
import { AmplitudeAnalyticsContext } from 'src/contexts/useAnalytics';
import { logoutClient } from 'src/redux/user/actions';
import { DiGithubBadge } from 'react-icons/di';
import { PiTelegramLogo } from 'react-icons/pi';
import { isAdmin } from 'src/utils/utils';
import { Image } from '@chakra-ui/react';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const dispatch = useAppDispatch();
  const userName = useAppSelector(getUserDisplayName);
  const photoURL = useAppSelector(getPhotoURL);
  const userType = useAppSelector(getUserType);
  const navigate = useNavigate();

  const getStoredState = (title: string) => {
    const stored = localStorage.getItem(`nav-${title}-state`);
    return stored ? JSON.parse(stored) : true;
  };

  const data = {
    user: {
      name: userName ?? 'Anonymous',
      avatar: photoURL ?? '',
    },
    navMain: [
      {
        title: 'Account',
        url: '/my-applications',
        icon: User,
        isActive: getStoredState('Account'),
        items: [
          {
            title: 'My Applications',
            url: '/my-applications',
          },
          {
            title: 'My Providers',
            url: '/my-providers',
          },
        ],
      },
      {
        title: 'Build',
        url: '/dashboard',
        icon: Hammer,
        isActive: getStoredState('Build'),
        items: [
          {
            title: 'Explore Providers',
            url: '/explore',
          },
          {
            title: 'Mobile App',
            type: 'MOBILE',
            url: '/new-application',
          },
          {
            title: 'Web App',
            type: 'WEB',
            url: '/new-application',
          },
          {
            title: 'zkFetchApp',
            type: 'ZK_FETCH',
            url: '/new-application',
          },
          {
            title: 'BlueCheck App',
            type: 'BC_APP',
            url: '/new-application',
          },
        ],
      },
    ],
    projects: [
      {
        name: 'GitHub',
        url: 'https://github.com/reclaimprotocol',
        icon: DiGithubBadge,
      },
      {
        name: 'Docs',
        url: 'https://docs.reclaimprotocol.org/',
        icon: BookOpen,
      },
      {
        name: 'Ask for help',
        url: 'https://t.me/protocolreclaim',
        icon: PiTelegramLogo,
      },
      {
        name: 'Talk to our Founder',
        url: 'https://t.me/sriharshakaramchati',
        icon: User2Icon,
      },
    ],
  };

  const auth = getAuth(app);
  const { amplitudeLogOut, setDashboardVisitCount } = useContext(
    AmplitudeAnalyticsContext
  );

  const handleSignOut = () => {
    dispatch(logoutClient());
    setDashboardVisitCount(0);
    amplitudeLogOut();
    signOut(auth);
    navigate('/');
  };

  return (
    <Sidebar collapsible="icon" {...props} >
      <SidebarHeader>
        <NavUser
          isAdmin={isAdmin(userType)}
          handleSignOut={handleSignOut}
          user={data.user}
        />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavResources projects={data.projects} />
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              size="lg"
              className=" cursor-default hover:bg-transparent px-4 my- disabled data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                <Image
                  src={Reclaim}
                  padding="4px"
                  borderRadius="7px"
                  bgColor="black"
                  h="32px"
                  w="32px"
                />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">Reclaim Protocol</span>
              </div>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
